import { environment } from '@environments/environment';


export type Config = Partial<typeof environment>;
const pingUrl = `${environment.base_url}/api/v1/health`;
const configUrl = environment.config_url;


let appConfig: typeof environment = { ...environment };
const emptyConfig: Config = {};


export const setConfig = (data: Config) => {
  appConfig = { ...appConfig, ...data };
};

export const getConfig = () => {
  return appConfig;
};


async function loadRemoteConfig(): Promise<Config> {
  try {
    const response = await fetch(configUrl);
    if (response.ok) {
      const config = await response.json();
      setConfig(config);
      return config;
    }
    throw new Error('Config is unavailable');
  } catch {
    throw new Error('Config is unavailable');
  }
}

export async function loadConfig(): Promise<Config> {
  if (!environment.production) {
    return new Promise((resolve) => resolve(emptyConfig));
  }
  try {
    await fetch(pingUrl, { signal: AbortSignal.timeout(1500) });
    return emptyConfig;
  } catch {
    return loadRemoteConfig();
  }
}


